export default __webpack_public_path__ + "static/market-index-treemap-b0bbb517b37e6cffd21a2ed443c4a1b2.png";